module.exports = __webpack_public_path__ + "static/media/infinity-war.1c26bfd1.png";